export default {
  posts: undefined
};



// WEBPACK FOOTER //
// ./src/redux/Posts/state.js